'use client';

import { H2_OPT, H3, P_OPT } from './styleConstants';
import { ParameterTile } from './ParameterTile';
import { useModal } from '..';
import { useEffect, useState } from 'react';
import { isMobileDevice } from 'utils/isMobile';
import { UhAppModal } from 'components/shared/UHAppDownloadModal';
import { CaretUp } from 'assets/icons';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import CustomLink from 'components/shared/CustomLink';
import styles from './TestCard.module.css';

const ExpandableContainer = ({ data }: { data: Array<any> }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className={`${styles.expandableRoot} u-hide-scrollbar${
        visible ? ' expanded' : ''
      }`}
    >
      {data?.map((param: any, idx: number) => (
        <ParameterTile
          title={param?.title}
          count={param?.subtitle}
          className={data.length > 5 && idx > 4 ? 'extra-param' : undefined}
          key={idx}
          index={idx}
        />
      ))}
      {data.length > 5 ? (
        <button
          onClick={() => {
            setVisible((prev) => !prev);
          }}
        >
          {visible ? (
            <span className={styles.moreParameter}>View less</span>
          ) : (
            <span className={styles.moreParameter}>
              +{data.length - 5} other parameters
            </span>
          )}{' '}
          {visible ? (
            <CaretUp
              fill="#000"
              style={{
                width: '8px',
                transform: visible
                  ? ' translateY(1px)'
                  : 'rotate(180deg) translateY(-2px)',
                marginLeft: '4px',
              }}
            />
          ) : null}
        </button>
      ) : null}
    </div>
  );
};

export const TestCard = ({ packageData }: { packageData?: any }) => {
  const [testData, setTestData] = useState<Array<any>>([]);

  const ModalClient = useModal();

  const { region: country } = useRegionLocale();

  const handleUHAppClick = () => {
    if (isMobileDevice()) {
      window.open('https://ultrahuman.onelink.me/QqSM/0ncoj3us', '_blank');
    } else {
      ModalClient.set(
        <UhAppModal
          text="Install the Ultrahuman app to start with your Blood Vision order."
          link="https://ultrahuman.onelink.me/QqSM/0ncoj3us"
          image="web_v2/qr-codes/blood-vision-onelink.png"
        />,
      );
      ModalClient.show();
    }
  };

  useEffect(() => {
    if (packageData?.info_details?.test_details) {
      setTestData(packageData?.info_details?.test_details);
    }
  }, [packageData]);

  return (
    <div className={styles.testCardRoot}>
      <div className={styles.topContent}>
        {/* <Image
          src="/peak_performance.svg"
          alt="Peak Performance Test"
          width={48}
          height={48}
        /> */}
        <H2_OPT>{packageData?.title ? packageData?.title : null}</H2_OPT>
        <P_OPT>
          {packageData?.description ? packageData?.description : null}
        </P_OPT>
        {country === 'IN' ? (
          <div className={styles.ctaContainer}>
            <span>{packageData.price_text ?? ''}</span>
            <CustomLink
              href="/blood-vision"
              className="primary"
              onClick={(e) => {
                e.preventDefault();
                handleUHAppClick();
              }}
            >
              Book now
            </CustomLink>
          </div>
        ) : null}
      </div>
      <div className={styles.bottomContent}>
        <H3>{packageData?.subtitle ? packageData?.subtitle : null}</H3>
        <div className="param-tiles">
          <ExpandableContainer data={testData} />
        </div>
      </div>
    </div>
  );
};
